export default __webpack_public_path__ + "static/media/GI.11549930.svg";